import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'projectInstructions',
    'rubric',
    'grades',
    'submit',
    'submissionForm',
    'hiddenRelaunch',
    'closeButton',
    'customIntercomLauncher',
  ];

  connect() {
    this.setupIntercomLauncher();
  }

  showInstructions() {
    this.projectInstructionsTarget.showModal();
  }
  relaunch() {
    this.activeClose();
    this.hiddenRelaunchTarget.click();
  }
  showRubric() {
    this.rubricTarget.showModal();
  }
  showGrades() {
    this.gradesTarget.showModal();
  }
  confirmSubmit() {
    this.submitTarget.showModal();
  }

  setupIntercomLauncher() {
    if (window.Intercom) {
      window.Intercom('update', { hide_default_launcher: true });
      this.customIntercomLauncherTarget.classList.remove('hidden');
    }
  }

  launchIntercom() {
    if (window.Intercom) {
      window.Intercom('show');
    }
  }

  activeClose() {
    this.closing = true;
  }

  closeAnyway() {
    const closestForm = this.closeButtonTarget.closest('form');
    if (!closestForm) return;
    if (this.closing) return;

    const data = new FormData(closestForm);
    navigator.sendBeacon(closestForm.action, data);
  }
}
